const API_BASE_URL = 'https://vlsiapi.bssoftcrm.com/api/v1.0';

export interface SendOtpRequest {
  emailAddress: string;
}

export interface SendOtpResponse {
  pageNumber: number;
  pageSize: number;
  succeeded: boolean;
  message: string | null;
  errors: string | null;
  data: {
    otp: string;
    message: string;
  };
}

// Send OTP API
export const sendOtp = async (
  emailAddress: string
): Promise<SendOtpResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/SendOtp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ emailAddress }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: SendOtpResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error;
  }
};
